import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";

const useStyles = makeStyles((theme) => ({
  inputLabelWrapper: {
    paddingBottom: theme.spacing(1),
  },
  formWrapper: {
    marginBottom: theme.spacing(2),
  },
  justifyBetween: {
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
  },
}));

const InputShell = ({ label, name, children, button, readOnly }: any) => {
  const classes = useStyles();

  return (
    <Box width="100%">
      <Box width="100%" className={button ? classes.justifyBetween : undefined}>
        {label && (
          <div className={classes.inputLabelWrapper}>
            <InputLabel
              htmlFor={name}
              disabled={readOnly}
              style={{ fontSize: 12 }}
            >
              {label}
            </InputLabel>
          </div>
        )}
        {button && (
          <Box display="flex" >
            {button}
          </Box>
        )}
      </Box>
      {children}
    </Box>
  );
};

const FormInputShell = ({ label, name, children, readOnly }: any) => {
  const classes = useStyles();
  const [, meta] = useField({ name });

  return (
    <Box width="100%" className={classes.formWrapper}>
      {label && (
        <div className={classes.inputLabelWrapper}>
          <InputLabel
            htmlFor={name}
            error={!!(meta.touched && meta.error)}
            disabled={readOnly}
            style={{ fontSize: 12 }}
          >
            {label}
          </InputLabel>
        </div>
      )}
      {children}
    </Box>
  );
};

FormInputShell.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node,
  readOnly: PropTypes.bool,
};

FormInputShell.defaultProps = {
  readOnly: false,
};

export default FormInputShell;
export { InputShell };
